import { CESimpleAttributeBase } from './ce-simple-attribute-base'


export class CESimpleAttribute extends CESimpleAttributeBase {

}